import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../../../index.scss';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import LocalPhone from '@material-ui/icons/LocalPhone';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import { isType, isType3, localeTw, userTypeList } from 'main_consts';

// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { Iobject } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import MenuIcon from '@material-ui/icons/Menu';
import Header from 'components/Header';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';
import { Divider } from '@material-ui/core';
import Radio from '../../../components/Radio';
// component
import Menu, { IMenu } from '../../../components/Menu';
import {
  formatDateTime,
  getColWidthByField,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  initWhrehhouse,
} from '../../../main_func';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getQRCodeSearch,
  getSearch,
  postSearch,
  snackBarRsp,
} from '../../../main_api';

// import Table from '../../../components/Material/Table/index';
import { Imaster, Iresult } from './type';
import Input from '../InvoiceQry/Input';

/** 查驗貨物清表 */
const InvCompare2DeclQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  const menuProps: IMenu = {
    guest: true, // 設定 guest 參數為 true
  };
  // call login
  const masterDefaultValue: Imaster = {
    /** 訂單號碼 */
    poNo: '',
    // 分號
    hawbNo: '',
    // QRCode
    qrCodeData: '',
    /** 總金額 */
    declNo: '',

    amount: '',
    // 銷售人姓名
    seContact: '',
    // 銷售人電話
    seContactTel: '',
    // 銷售人地址
    seAddress: '',

    // 收貨人姓名
    cnContact: '',
    // 收貨人電話
    cnContactTel: '',
    // 收貨人地址
    cnAddress: '',
  };
  const apiName = 'invCompare2DeclQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [rowData, setRowData] = useState<unknown[]>([]);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };
  const [value, setValue] = useState('');
  const [mobileMenuShow, setMobileMenuShow] = useState<boolean>(false);

  function isAdmin(): boolean {
    return (
      isType(userTypeList.type4, userType) ||
      isType(userTypeList.admin, userType) ||
      isType(userTypeList.topType, userType)
    );
  }

  useEffect(() => {
    isAdmin();
  }, [userType]);

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postSearch(apiName, {
      poNo: master.poNo,
      hawbNo: master.hawbNo,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    const { data: dataTemp } = result.data;

    const data = dataTemp as Iresult;
    setRandomValue(Math.random());
  };

  const handleMobile = () => {
    setMobileMenuShow(!mobileMenuShow);
  };
  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    switch (submitKey) {
      case 'search':
        handleMobile();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);

    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  const cellStyle = {
    border: '1px solid', // 新增邊框樣式
    padding: '8px', // 新增內邊距樣式（可依需求調整）
  };
  return (
    <div id="page-area">
      <Header guest />
      <div className="breadcrumbs-area" />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 商業發票與報單資料比對
          </div>
        </div>
        {userType && isAdmin() && (
          <div className="input-area">
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  <FormTitle>*提單分號/袋號：</FormTitle>
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={35}
                    value={master.hawbNo || ''}
                    name="hawbNo"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
                <VcEGrid item className="input-text">
                  訂單號碼：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={35}
                    value={master.poNo}
                    name="poNo"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
                <VcEGrid item className="input-text">
                  報單號碼：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={35}
                    value={master.declNo}
                    name="declNo"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        )}
        <Grid container className="button-area">
          {userType && isAdmin() && (
            <>
              <VcEGrid item xs={12} sm={2}>
                <Button
                  className="search-btn"
                  disabled={formError}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<SearchIcon />}
                  onClick={() => setSubmitKey('search')}
                >
                  查詢
                </Button>
              </VcEGrid>
              <Grid item xs={12} sm="auto">
                <Button
                  disabled={formError}
                  type="submit"
                  variant="contained"
                  color="default"
                  startIcon={<PrintIcon />}
                  onClick={() => setSubmitKey('download')}
                >
                  查詢發票明細
                </Button>
              </Grid>
              <Grid item xs={12} sm="auto">
                <Button
                  disabled={
                    userTypeList.type4.some((v) => v === userType) &&
                    locationCode.trim().length === 0
                  }
                  variant="outlined"
                  color="primary"
                  startIcon={<RefreshIcon />}
                  onClick={() => handleReset()}
                >
                  重置
                </Button>
              </Grid>
            </>
          )}
        </Grid>

        {mobileMenuShow && (
          <>
            <div className="input-area">
              <div>
                <Grid container>
                  <VcEGrid item className="input-text">
                    <FormTitle>實名認證：</FormTitle>
                  </VcEGrid>
                  <Grid item>
                    <Input
                      maxLength={4}
                      value={master.declNo || 'V'}
                      name="declNo2"
                      onChange={(e) => {
                        inputChange(updateData)(e);
                      }}
                    />
                  </Grid>
                  <VcEGrid item className="input-text">
                    委任狀況：
                  </VcEGrid>
                  <Grid item>
                    <Input
                      maxLength={4}
                      value={master.declNo || ''}
                      name="declNo3"
                      onChange={(e) => {
                        inputChange(updateData)(e);
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
            <div
              style={{
                justifyContent: 'center',
                display: 'flex',
                marginTop: 10,
              }}
            >
              <table
                style={{
                  border: 1,
                  borderStyle: 'solid',
                  borderCollapse: 'collapse',
                  width: '80%',
                }}
              >
                <tr>
                  <td style={cellStyle}>比對欄位</td>
                  <td style={cellStyle}>商業發票</td>
                  <td style={cellStyle}>通關報單</td>
                  <td style={cellStyle}>比對狀況</td>
                </tr>
                <tr>
                  <td style={cellStyle}>納稅義務人名稱</td>
                  <td style={cellStyle}>王小明</td>
                  <td style={cellStyle}>王小明</td>
                  <td style={cellStyle}>相符</td>
                </tr>
                <tr>
                  <td style={cellStyle}>總金額</td>
                  <td style={cellStyle}>100</td>
                  <td style={cellStyle}>100</td>
                  <td style={cellStyle}>相符</td>
                </tr>
                <tr>
                  <td style={cellStyle}>件數</td>
                  <td style={cellStyle}>1</td>
                  <td style={cellStyle}>2</td>
                  <td style={cellStyle}>不相符</td>
                </tr>
              </table>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default InvCompare2DeclQry;
